import type { DetailsData } from 'data/types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

interface Props {
  data: DetailsData
}

export default function StoresCountDetails({ data }: Props) {
  const { t: translate } = useTranslation()
  const classes = useStyles()

  return (
    <Box display="flex" marginBottom="1.4rem" marginTop="1.4rem">
      <div>
        <div>
          {translate('revenue.stats.storesOpen')}: <span className={classes.value}>{data.storesCurrentNECom}</span>
        </div>
        <div>
          {translate('revenue.stats.websitesOpen')}: <span className={classes.value}>{data.storesCurrentECom}</span>
        </div>
      </div>
      <Box ml={3}>
        <div>
          {translate('revenue.stats.storesActive')}: <span className={classes.value}>{data.storesCurrentActive}</span>
        </div>
        <div>
          {translate('revenue.stats.websitesActive')}: <span className={classes.value}>{data.storesCurrentEComActive}</span>
        </div>
      </Box>
    </Box>
  )
}
